/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * BYOB - Personalizaciones para "Crea tu propio pack"
   * 1. Cambiar texto del botón "Agregar al Kit" por "Añadir [nombre del vino]"
   * 2. Ocultar selector cuando solo hay una opción disponible
   * 3. Crear botones del step builder para navegación entre pasos
   */
  
  function customizeBYOB() {
    // Función para crear botones del step builder
    function createStepBuilderButtons() {
      // Buscar el contenedor de BYOB
      const byobApp = document.querySelector('#byobApp');
      if (!byobApp) return;
      
      // Verificar si ya existen los botones
      if (document.querySelector('.byob-step-builder-container')) return;
      
      // Buscar todos los acordeones
      const accordions = document.querySelectorAll('.byob-accordion');
      if (accordions.length === 0) return;
      
      // Crear contenedor de botones
      const container = document.createElement('div');
      container.className = 'byob-step-builder-container';
      
      const header = document.createElement('div');
      header.className = 'byob-step-builder-header';
      
      const buttonsContainer = document.createElement('div');
      buttonsContainer.className = 'byob-step-builder-buttons';
      
      // Crear un botón para cada acordeón
      accordions.forEach(function(accordion, index) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'byob-step-builder-btn';
        if (accordion.classList.contains('activeTab')) {
          button.classList.add('active');
        }
        
        // Extraer el número y título del acordeón
        const accordionNumber = accordion.querySelector('.byob-accordion-number');
        const accordionText = accordion.textContent.trim();
        
        // Extraer el título (después del número)
        let title = accordionText;
        if (accordionNumber) {
          title = accordionText.replace(accordionNumber.textContent, '').trim();
          // Limpiar el texto para obtener solo el título principal
          title = title.replace(/^Selecciona\s+al\s+menos\s+\d+\s+item\(s\)\s+desde\s+/i, '');
        }
        
        // Crear número del paso
        const stepNumber = document.createElement('span');
        stepNumber.className = 'step-number';
        stepNumber.textContent = (index + 1);
        
        // Crear título del paso
        const stepTitle = document.createElement('span');
        stepTitle.className = 'step-title';
        stepTitle.textContent = title;
        
        button.appendChild(stepNumber);
        button.appendChild(stepTitle);
        
        // Agregar evento click
        button.addEventListener('click', function() {
          // Remover active de todos los botones y acordeones
          document.querySelectorAll('.byob-step-builder-btn').forEach(function(btn) {
            btn.classList.remove('active');
          });
          document.querySelectorAll('.byob-accordion').forEach(function(acc) {
            acc.classList.remove('activeTab');
            const panel = acc.nextElementSibling;
            if (panel && panel.classList.contains('byob-panel')) {
              panel.style.display = 'none';
            }
          });
          
          // Activar el botón y acordeón seleccionado
          button.classList.add('active');
          accordion.classList.add('activeTab');
          const panel = accordion.nextElementSibling;
          if (panel && panel.classList.contains('byob-panel')) {
            panel.style.display = '';
          }
          
          // Scroll suave al acordeón
          accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        
        buttonsContainer.appendChild(button);
      });
      
      header.appendChild(buttonsContainer);
      container.appendChild(header);
      
      // Insertar antes del primer acordeón
      const firstAccordionContainer = document.querySelector('.byob-accordion-container');
      if (firstAccordionContainer && firstAccordionContainer.parentElement) {
        firstAccordionContainer.parentElement.insertBefore(container, firstAccordionContainer);
      } else if (byobApp) {
        byobApp.insertBefore(container, byobApp.firstChild);
      }
    }
    // Función para actualizar el texto de los botones
    function updateButtonTexts() {
      // Buscar todos los botones de "Agregar al Kit"
      const addToBundleButtons = document.querySelectorAll('[class*="byob"][class*="add"], button[class*="byob"], .byob-add-to-bundle-btn, .byob-product-card button');
      
      addToBundleButtons.forEach(function(button) {
        const buttonText = button.textContent || button.innerText;
        
        // Si el botón contiene "Agregar al Kit" o texto similar
        if (buttonText.includes('Agregar al Kit') || buttonText.includes('Add to Bundle') || buttonText.includes('Agregar')) {
          // Buscar el nombre del producto en la tarjeta contenedora
          const productCard = button.closest('.byob-product-card, .byob-grid-item, .byob-product-item, [class*="byob-product"]');
          
          if (productCard) {
            // Intentar encontrar el nombre del producto
            const productName = productCard.querySelector('.byob-product-name, .byob-product-title, h3, h4, [class*="product-name"], [class*="title"]');
            
            if (productName) {
              const wineName = productName.textContent.trim();
              // Actualizar el texto del botón
              if (buttonText.includes('Agregar al Kit')) {
                button.textContent = 'Añadir ' + wineName;
              } else if (buttonText.includes('Add to Bundle')) {
                button.textContent = 'Add ' + wineName;
              } else {
                button.textContent = 'Añadir ' + wineName;
              }
            }
          }
        }
      });
    }

    // Función para ocultar selectores con una sola opción
    function hideSingleOptionSelectors() {
      const optionSelectors = document.querySelectorAll('.byob-product-option1, .byob-product-option, .byob-grid-product-options');
      
      optionSelectors.forEach(function(optionContainer) {
        const select = optionContainer.querySelector('select.byob-gpo-select, select');
        
        if (select) {
          // Contar opciones habilitadas (no disabled)
          const enabledOptions = Array.from(select.options).filter(function(option) {
            return !option.disabled && option.value !== '';
          });
          
          // Si solo hay una opción habilitada, ocultar el contenedor
          if (enabledOptions.length === 1) {
            optionContainer.classList.add('byob-single-option-hidden');
            optionContainer.style.display = 'none';
            
            // Asegurar que el valor se seleccione automáticamente
            if (enabledOptions[0].value) {
              select.value = enabledOptions[0].value;
              // Disparar evento change para que BYOB detecte el cambio
              const changeEvent = new Event('change', { bubbles: true });
              select.dispatchEvent(changeEvent);
            }
          } else {
            // Si hay más de una opción, mostrar el selector
            optionContainer.classList.remove('byob-single-option-hidden');
            optionContainer.style.display = '';
          }
        }
      });
    }

    // Ejecutar personalizaciones cuando el DOM esté listo
    function initCustomizations() {
      setTimeout(function() {
        updateButtonTexts();
        hideSingleOptionSelectors();
        createStepBuilderButtons();
      }, 500);
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomizations);
    } else {
      initCustomizations();
    }

    // Observar cambios dinámicos en el DOM (BYOB carga productos dinámicamente)
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        setTimeout(function() {
          updateButtonTexts();
          hideSingleOptionSelectors();
          createStepBuilderButtons();
        }, 300);
      }
    });

    // Observar cambios en el contenedor de BYOB
    const byobContainer = document.querySelector('.byob-container, .byob-wrapper, [class*="byob"]');
    if (byobContainer) {
      observer.observe(byobContainer, {
        childList: true,
        subtree: true
      });
    }

    // También observar cambios en todo el documento por si BYOB se carga después
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Re-ejecutar cuando se hace clic en elementos de BYOB (puede cargar más productos)
    document.addEventListener('click', function(e) {
      if (e.target.closest('[class*="byob"]')) {
        setTimeout(function() {
          updateButtonTexts();
          hideSingleOptionSelectors();
          // Actualizar estado activo de los botones del step builder
          const activeAccordion = document.querySelector('.byob-accordion.activeTab');
          if (activeAccordion) {
            const accordions = Array.from(document.querySelectorAll('.byob-accordion'));
            const index = accordions.indexOf(activeAccordion);
            const buttons = document.querySelectorAll('.byob-step-builder-btn');
            if (buttons[index]) {
              buttons.forEach(function(btn) { btn.classList.remove('active'); });
              buttons[index].classList.add('active');
            }
          }
        }, 200);
      }
    }, true);
  }

  // Inicializar personalizaciones de BYOB
  customizeBYOB();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
